import { Component, OnInit, ViewChildren, QueryList, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Env, Versions, VersionsFilter } from '@usimweb/core/models';
import { ProjectcardComponent } from '@usimweb/ui/shared';
import { DialogService } from '@usimweb/ui/dialogs';
import { ApiService } from '@usimweb/core/services';

import { Store } from '@ngrx/store';
import { Observable, filter, map, skip } from 'rxjs';
import { DialogHandler } from './dialogHandler';

import * as fromStore from '@usimweb/state/store';
import * as fromRoot from '@usimweb/state/router-store';

@Component({
    selector: 'app-versions',
    templateUrl: './versions.component.html',
    styleUrls: ['./versions.component.scss'],
    standalone: false
})
export class VersionsComponent extends DialogHandler implements OnInit, OnDestroy {
  public versions$!: Observable<Versions[]>;
  public progress$!: Observable<boolean>;

  public uuid: string = '';
  public isCompare = false;
  public newVersionLink!: string;
  public versionLink: string = this.environment.versionLink;

  @ViewChildren('cardItem') projectcardComponent!: QueryList<ProjectcardComponent>;

  constructor(
    @Inject('environment') private environment: Env,
    private route_: ActivatedRoute,
    private store: Store<fromStore.DashboardState>,
    private compare: fromStore.CompareService,
    private dialogService: DialogService,
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    super(store, dialogService, apiService, snackBar, router);
  }

  ngOnInit(): void {
    this.uuid = this.route_.snapshot.paramMap.get('id')?.toString() || '';
    this.newVersionLink = this.environment.newVersionLink + '/' + this.uuid;

    this.progress$ = this.store.select<boolean>(fromStore.getVersionsLoading);
    this.versions$ = this.store.select(fromStore.getAllVersions);

    this.refreshCallback.pipe(skip(1)).subscribe(() => {
      this.store.dispatch(new fromStore.LoadVersions(this.uuid));
    });
  }

  ngOnDestroy(): void {
    this.store.dispatch(new fromStore.CancelPolling());
  }

  back(): void {
    this.store.dispatch(new fromRoot.Go({ path: ['/app/projects'] }));
  }

  public indexChanged(index: number): void {
    this.compare.navigate(this.uuid, index, this.projectcardComponent);
  }

  public toggleCompare(compare: boolean): void {
    this.isCompare = !this.isCompare;
    this.compare.toggle(compare, this.projectcardComponent);
    this.versions$ = this.store
      .select(fromStore.getAllVersions)
      .pipe(map((array) => (!this.isCompare ? array : array.filter((x) => x.status.overall !== 'failed'))));
  }

  public filter(filter: VersionsFilter) {
    this.store.dispatch(new fromStore.SetFilter(filter));
  }

  public route(path: string) {
    // console.log('route to new version');
    // do not call if version was clicked
    // this.sub.unsubscribe();
    // console.log('ngOnDestroy called unsubscribed all observables!!!');
    this.store.dispatch(new fromStore.GoNewVersion(path));
  }

  public openDialog(event: any) {
    this.open(event);
  }
}
